import React from "react";

export default function TriggerIcon({ className, size = 14, strokeWidth = 1.401, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="1.4 0.7 14.7 14.7"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M8.408 9.109V6.306m6.307-2.102-1.402-1.401M7.007 1.4H9.81M8.408 14.715a5.606 5.606 0 1 1 0-11.212 5.606 5.606 0 0 1 0 11.212" />
    </svg>
  );
}
